import React from 'react'
import cn, { Argument as ClassName } from 'classnames'
import { Button } from 'primereact/button'

import Text from '../../../../../ui/Text'
import { GreenChargingIcon } from '../../../../../lib/icons/green-charging-icon'
import storage from '../../../../../common/utils/storage'
import useText from '../../../../../common/hooks/useText'
import { Dialog } from '../../../../../common/uikit/Dialog'

const getGreenChargingAppLink = () => {
    const language = storage.getItem('userLocale')
    const notLocalized = ['en', 'fr', 'nl', 'es', 'pt']
    if (!language || notLocalized.includes(language.toString())) {
        return 'https://www.chargeamps.com/chargeamps-app/'
    }

    return `https://www.chargeamps.com/${language}/chargeamps-app/`
}

export type GreenChargingDialogProps = {
    visible: boolean
    onAccept: () => void
    close: () => void
    className?: ClassName
    style?: React.CSSProperties
}

export function GreenChargingDialog({
    visible,
    className,
    style,
    close,
    onAccept,
}: GreenChargingDialogProps): React.ReactElement {
    const text = useText()

    const handleClose = () => {
        close()
        onAccept()
    }

    const footer = (
        <div className="flex justify-content-end">
            <Button label={text('btnClose')} type="button" onClick={handleClose} data-testid="green-charging-close" />
        </div>
    )

    return (
        <Dialog
            visible={visible}
            onHide={handleClose}
            header={text('lblGreenChargingDialogTitle')}
            footer={footer}
            className={cn(className)}
            style={style}
            data-testid="green-charging-dialog"
        >
            <div className="flex flex-column align-items-center gap-4">
                <GreenChargingIcon />
                <div className="w-full max-w-22rem text-center line-height-3">
                    <Text
                        code="msgGreenChargingDialogDescription"
                        values={{
                            link: {
                                href: getGreenChargingAppLink(),
                                target: '_blank',
                                rel: 'noopener noreferrer',
                            },
                        }}
                    />
                </div>
            </div>
        </Dialog>
    )
}
